import { Link } from "react-router-dom";

const NotFound = () => (
  <main className="min-h-screen bg-[#050505] px-6 pt-32 text-center">
    <p className="mb-4 text-xs uppercase tracking-[0.3em] text-[#D4AF37]">404</p>
    <h1 className="mb-4 text-4xl text-[#EDEDED]">Page not found</h1>
    <p className="mx-auto mb-8 max-w-xl text-[#A1A1AA]">
      The page you requested does not exist or may have moved.
    </p>
    <Link to="/" className="btn-gold inline-flex">
      Return to Breedling
    </Link>
  </main>
);

export default NotFound;
